module.exports = __webpack_public_path__ + "img/downloadImg.a3e00d96.png";